/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Calendar_Empty_WriteInputs */

const en_landing_calendar_empty_write = /** @type {(inputs: Landing_Calendar_Empty_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write in and we will find you a time.`)
};

const pl_landing_calendar_empty_write = /** @type {(inputs: Landing_Calendar_Empty_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napisz, a znajdziemy Ci termin.`)
};

/**
* | output |
* | --- |
* | "Write in and we will find you a time." |
*
* @param {Landing_Calendar_Empty_WriteInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_calendar_empty_write = /** @type {((inputs?: Landing_Calendar_Empty_WriteInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Calendar_Empty_WriteInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_calendar_empty_write(inputs)
	return en_landing_calendar_empty_write(inputs)
});